'use client';

import { createContext, useContext } from 'react';

interface FlowboxContextType {
  containerId?: string;
  flowKey: string;
  locale?: string;
  productId?: string;
  showTags?: boolean;
  tags?: string;
  viewAll?: string;
}

const FlowboxContext = createContext<FlowboxContextType | null>(null);

export const useFlowbox = () => {
  const context = useContext(FlowboxContext);
  if (!context) {
    throw new Error('useFlowbox must be used within a FlowboxProvider');
  }
  return context;
};

export const FlowboxProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: FlowboxContextType;
}) => {
  return (
    <FlowboxContext.Provider value={value}>{children}</FlowboxContext.Provider>
  );
};

export default FlowboxProvider;
